import { createSlice } from '@reduxjs/toolkit';

const sessionSlice = createSlice({
    name: 'session',
    initialState: {
        sessionExpiry: null,
    },
    reducers: {
        setSessionExpiry: (state, action) => {
            state.sessionExpiry = action.payload;
        },
        clearSessionExpiry: (state) => {
            state.sessionExpiry = null;
        },
    },
});

export const { setSessionExpiry, clearSessionExpiry } = sessionSlice.actions;

export default sessionSlice.reducer;